export const VIEW_TRANSITION_LOG_TAG = '[ViewTransition]';

export const BROWSER_BACK_NAVIGATION_DETECTED_MESSAGE = 'Browser back navigation detected';
export const NAVIGATION_HAS_NATIVE_TRANSITION_MESSAGE = 'Navigation has native transition';

export const BACKWARDS_CLASS = 'view-transition-backwards';
export const FULL_SLIDE_CLASS = 'view-transition-full-slide';

export const EXCLUDE_NONE_CLASS = 'view-transition-modifier-exclude-none';
export const EXCLUDE_HEADER_CLASS = 'view-transition-modifier-exclude-header';
export const EXCLUDE_BOTTOM_NAV_CLASS = 'view-transition-modifier-exclude-bottom-nav';
export const EXCLUDE_BETSLIP_CLASS = 'view-transition-modifier-exclude-betslip';
export const EXCLUDE_QUICK_BET_CLASS = 'view-transition-modifier-exclude-quick-bet';

export const VIEW_TRANSITION_EPCOT_CSS_CLASS = 'view-transition-epcot';

export const TRANSITION_PATHS = {
    AC_MENU_OVERLAY_PATH: ':menu',
    AC_MENU_PATH: '/menu',
    AZ_MENU_PATH: '/product-menu',
    EVENTS_PATH: '/events',
};
